<template>
  <div>
    Component settings detail content
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
@Options({})
export default class Content extends Base {}
</script>
